/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAbsoluteSmoothScrollData } from './absolute-smooth-scroll.data';
import { IAbsoluteSmoothScrollProps } from './absolute-smooth-scroll.props.autogenerated';

export interface IAbsoluteSmoothScrollViewProps extends IAbsoluteSmoothScrollProps<IAbsoluteSmoothScrollData> {

    smoothLink: string;
    buttonText: string;


}



   

/**
 *
 * AbsoluteSmoothScroll component
 * @extends {React.PureComponent<IAbsoluteSmoothScrollProps<IAbsoluteSmoothScrollData>>}
 */
class AbsoluteSmoothScroll extends React.PureComponent<IAbsoluteSmoothScrollProps<IAbsoluteSmoothScrollData>> {

    
      

    public render(): JSX.Element | null {

        const { config } = this.props;

       

        const ButtonText = config.buttonText ? config.buttonText : '';
        const SmoothLink = config.smoothLink ? config.smoothLink : '';

        const AbsoluteSmoothProps = {
            ...this.props,
            smoothLink: SmoothLink,
            buttonText: ButtonText

        };


        return this.props.renderView(AbsoluteSmoothProps) as React.ReactElement;
    }
}

export default AbsoluteSmoothScroll;
